import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-circle-plus.svg'
import _imports_1 from '@/assets/images/icon-eye.svg'
import _imports_2 from '@/assets/images/icon-home.svg'
import _imports_3 from '@/assets/images/icon-store.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c625469"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-9 w-full h-full gap-2" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-span-7 grid grid-cols-7 w-full p-3" }
const _hoisted_5 = { class: "col-span-7 visible lg:hidden flex" }
const _hoisted_6 = { class: "items-center justify-center gap-4 flex mb-2" }
const _hoisted_7 = { class: "col-span-7 lg:col-span-6 flex flex-col gap-1 w-full h-full" }
const _hoisted_8 = { class: "flex items-center w-full justify-between lg:px-7" }
const _hoisted_9 = { class: "flex flex-col lg:flex-row font-bold w-full gap-2 items-start lg:items-center justify-start" }
const _hoisted_10 = {
  key: 0,
  class: "mb-1 flex items-center justify-start gap-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "lg:w-full h-4"
}, null, -1))
const _hoisted_12 = { class: "lg:hidden visible font-bold text-[16px]" }
const _hoisted_13 = {
  key: 1,
  class: "mb-1 flex items-center justify-start gap-1"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "lg:w-full h-4"
}, null, -1))
const _hoisted_15 = { class: "lg:hidden visible font-bold text-[16px]" }
const _hoisted_16 = { class: "hidden lg:block lg:visible font-bold text-[16px]" }
const _hoisted_17 = { class: "lg:flex-1 flex flex-row justify-between items-center pb-2" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col lg:mx-[4%]"
}
const _hoisted_19 = { class: "flex-1 items-end flex justify-start lg:justify-between mt-3 lg:mt-0" }
const _hoisted_20 = { class: "flex lg:mx-[4%] gap-2 just" }
const _hoisted_21 = { class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#F6FFAD] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Valor de compra:", -1))
const _hoisted_23 = {
  key: 0,
  class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#CCED57] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Renta:", -1))
const _hoisted_25 = {
  key: 1,
  class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#CCED57] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Renta:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_28 = { class: "col-span-7 lg:col-span-1 flex flex-col justify-between lg:items-center items-start" }
const _hoisted_29 = { class: "hidden lg:visible lg:flex items-center justify-center gap-4" }
const _hoisted_30 = { class: "flex lg:items-center items-start gap-2" }
const _hoisted_31 = { class: "max-w-[81px]" }
const _hoisted_32 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewInvestimentModal = _resolveComponent("PreviewInvestimentModal")!
  const _component_EditInvestmentModal = _resolveComponent("EditInvestmentModal")!
  const _component_InvestimentModal = _resolveComponent("InvestimentModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "cursor-pointer w-full h-fit card-invest rounded-lg overflow-hidden bg-white",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleEdit && _ctx.handleEdit(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.invest?.thumbnail != null)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.getEnvConfig().apiURL + _ctx.invest.thumbnail.slice(1),
                alt: "rentas-dhelos-invest",
                class: "bg-cover h-full w-full object-cover"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "h-4",
                onClick: _cache[0] || (_cache[0] = (e) => _ctx.handleAddRecord(e))
              }),
              _createElementVNode("img", {
                src: _imports_1,
                class: "h-4",
                onClick: _cache[1] || (_cache[1] = (e) => _ctx.handlePreview(e))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.InvestimentEnum[0] == _ctx.invest?.investmentType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.invest?.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.InvestimentEnum[1] == _ctx.invest?.investmentType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.invest?.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.invest?.title), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["lg:flex flex-row lg:mx-[4%] gap-2", 
                  _ctx.invest?.investmentStatus == 'ARRENDADO'
                    ? 'text-red-700'
                    : _ctx.invest?.investmentStatus == 'DISPONIBLE'
                    ? 'text-green-700'
                    : ''
                ])
                }, _toDisplayString(_ctx.upercaseToTitle(_ctx.invest?.investmentStatus)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.invest?.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatSeparateLine(_ctx.invest?.description), (desc) => {
                      return (_openBlock(), _createElementBlock("p", { key: desc }, _toDisplayString(desc), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("p", null, "UF " + _toDisplayString(_ctx.toBadgeFormat(_ctx.invest.value)), 1)
                ]),
                (_ctx.invest.monthlyProfitabilityClp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", null, "$" + _toDisplayString(_ctx.toBadgeFormat(_ctx.invest.monthlyProfitabilityClp)) + " mes", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.invest.monthlyProfitabilityUf)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("p", null, " UF " + _toDisplayString(_ctx.toBadgeFormatUf(_ctx.invest.monthlyProfitabilityUf)) + " mes ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "h-4",
                onClick: _cache[2] || (_cache[2] = (e) => _ctx.handleAddRecord(e))
              }),
              _createElementVNode("img", {
                src: _imports_1,
                class: "h-4",
                onClick: _cache[3] || (_cache[3] = (e) => _ctx.handlePreview(e))
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (_ctx.lastRecordDaste != null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.getNumberOfDays(_ctx.lastRecordDaste) == 0
                    ? "Última actulalización : hoy"
                    : "Último registro hace " +
                      _ctx.getNumberOfDays(_ctx.lastRecordDaste) +
                      " días"), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_33, "No existen registros"))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.invest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            (_openBlock(), _createBlock(_component_PreviewInvestimentModal, {
              visible: _ctx.showModalPreview,
              "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModalPreview) = $event)),
              invest: _ctx.invest,
              type: 0,
              key: _ctx.keyIndexInvestModal
            }, null, 8, ["visible", "invest"]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.invest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (_openBlock(), _createBlock(_component_EditInvestmentModal, {
              visible: _ctx.showModalEdit,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModalEdit) = $event)),
              onReload: _ctx.reloadInfo,
              invest: _ctx.invest,
              type: 0,
              id: _ctx.invest?.id,
              key: _ctx.keyIndexInvestModal
            }, null, 8, ["visible", "onReload", "invest", "id"]))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_InvestimentModal, {
        visible: _ctx.showModal,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
        type: 1,
        id: _ctx.invest?.id,
        onReload: _ctx.reload
      }, null, 8, ["visible", "id", "onReload"])
    ]),
    _hoisted_36
  ], 64))
}